import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 text-secondary-800 px-3 py-1 text-xs">
            <i className="ri-question-line"></i>帮助中心
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">追更常见问题</h2>
          <p className="mt-3 text-sm text-foreground-600">关于每日更新与追更提醒，你想知道的都在这里</p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={item.q}
                className={`rounded-lg border bg-background-50 overflow-hidden transition-colors ${
                  open ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : idx)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <h3 className="text-sm md:text-base font-medium text-foreground-950">{item.q}</h3>
                  <span
                    className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm transition-colors ${
                      open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      ></script>
    </section>
  );
}